<ion-button color="primary" (click)="clickButton()">{{ buttonText }}</ion-button>
